export default "__VITE_ASSET__5QXZtjSo__"